import React, { useCallback, useState } from "react";
import { Button, HorizontalStack } from "@shopify/polaris";
import { ExportMinor, ExternalMinor } from "@shopify/polaris-icons";
import { useCustomerList } from "../../context/CustomerListContext";
import { ButtonBoldText } from "@vendor-app/app/_sharedComponents/ButtonBold";
import { useActiveOrganizationSelector } from "@vendor-app/app/_state/reducers/organizations";
import { useToast } from "@vendor-app/app/_sharedComponents/Toast/ToastProvider";
import { frontEndTabOpen } from "@smartrr/shared/utils/locationUtils";
import { exportCustomersToCsvRows } from "@vendor-app/utils/exportCustomersToCsvRows";
import { createAndDownloadCsv } from "@vendor-app/app/../utils/createAndDownloadCsv";

export function PageActions() {
  const [exportToCSVIsLoading, setExportToCSVIsLoading] = useState(false);
  const { state } = useCustomerList();
  const { isLoading, searchQuery } = state;
  const activeOrg = useActiveOrganizationSelector();
  const { addToast } = useToast();

  const exportToCsv = useCallback(async () => {
    setExportToCSVIsLoading(true);
    try {
      const filters = searchQuery.trim()
        ? {
            filterLike: {
              emailOrName: searchQuery.trim(),
            },
          }
        : undefined;

      const rows = await exportCustomersToCsvRows(filters);

      if (rows) {
        createAndDownloadCsv(rows, "Customers");
      }
    } catch {
      addToast("Error exporting to CSV");
    } finally {
      setExportToCSVIsLoading(false);
    }
  }, [searchQuery]);

  const viewCustomersInShopify = () => {
    if (!activeOrg?.myShopifyDomain) {
      addToast("Can't open in Shopify");
      return;
    }
    frontEndTabOpen(`https://${activeOrg.myShopifyDomain}/admin/customers`);
  };

  return (
    <HorizontalStack align="start" blockAlign="center" gap="400">
      <ButtonBoldText>
        <Button
          plain
          monochrome
          removeUnderline
          icon={ExportMinor}
          disabled={isLoading}
          loading={exportToCSVIsLoading}
          onClick={exportToCsv}
        >
          Export to CSV
        </Button>
      </ButtonBoldText>
      <ButtonBoldText>
        <Button plain monochrome removeUnderline icon={ExternalMinor} onClick={viewCustomersInShopify}>
          View in Shopify
        </Button>
      </ButtonBoldText>
    </HorizontalStack>
  );
}
